import CacheCleaner from "./CacheCleaner"
import CacheManager from "../CacheManager"


export default class TierCleaner extends CacheCleaner {

	async onMutation(tiers_ids) {
		await this.init()

		await CacheManager.inst().onObjectsMutation('tiers', tiers_ids, ['phone_combine'])
	}
}
